import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import oilProductionService from "../../services/oilProduction/oilProductionservice";

export default function DesiriOilIntakeTable() {
  const [oilIntakeLogs, setOilIntakeLogs] = useState([]);
  const [globalFilter, setGlobalFilter] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [totalOilSeedWeight, setTotalOilSeedWeight] = useState<number>(0);
  const dt = useRef(null);
  const toast = useRef<Toast>(null);

  useEffect(() => {
    loadIntakeLogs();
  }, []);

  const loadIntakeLogs = async () => {
    try {
      setLoading(true);
      const response = await oilProductionService.getAllOilIntakeLogs();
      setOilIntakeLogs(response);
      const totalWeight = response.reduce(
        (sum: number, item: any) => sum + (item.oilSeedWeight || 0),
        0
      );
      setTotalOilSeedWeight(totalWeight);
    } catch (error) {
      console.error("Failed to fetch oil intake logs", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to load records",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setGlobalFilter("");
  };

  const header = (
    <div className="flex flex-col md:flex-row justify-between items-center gap-3 mb-3">
      <div className="text-xl font-semibold text-gray-700">Oil Intake Logs</div>
      <div className="flex items-center gap-2">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            placeholder="Search..."
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="p-inputtext-sm"
          />
        </span>
        <Button
          icon="pi pi-refresh"
          className="p-button-sm p-button-secondary"
          label="Reset"
          onClick={handleReset}
        />
      </div>
    </div>
  );

  return (
   <div className="card border-noround p-2">
    
      <DataTable
        ref={dt}
        value={oilIntakeLogs}
        paginator
        rows={10}
        loading={loading}
        stripedRows
        scrollable
        globalFilter={globalFilter}
        header={header}
        emptyMessage="No oil intake logs found."
        className="p-datatable-sm"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column field="id" header="ID" style={{ width: "70px" }} />
        <Column
          field="submittedDate"
          header="Submitted Date"
          body={(rowData) =>
            new Date(rowData.submittedDate).toLocaleDateString()
          }
        />
        <Column field="startTime" header="Start Time" />
        <Column field="endTime" header="End Time" />
        <Column field="oilSeedName" header="Oilseed" />
        <Column field="oilSeedWeight" header="Seed Weight (kg)" />
        <Column field="moistureContent" header="Moisture (%)" />
        <Column field="emptyContainerWeightKG" header="Container Weight (kg)" />
        <Column field="vendorName" header="Vendor" />
        <Column field="rawMaterialName" header="Raw Material" />
        <Column field="gaanaName" header="Gaana Used" />
        <Column field="bull1Name" header="Bull 1" />
        <Column field="bull2Name" header="Bull 2" />
        <Column field="operator1Name" header="Operator 1" />
        <Column field="operator2Name" header="Operator 2" />
        <Column
          field="createdDate"
          header="Created At"
          body={(rowData) => new Date(rowData.createdDate).toLocaleString()}
        />
      </DataTable>
    </div>
  );
}
